const navItemCls = "_61nuf6utk";
const itemContentCls = "_61i17ntmpy";
const linkCls = "_61l2yqff7";
const switchTransitionCls = "_61ssl9e4q";
const switchCls = "_61s5zsjz8";
const linkChevron = "_61l1kf44p";
const revisionIconWrapper = "_61rtqb76a";
const expandButtonCls = "_61e8dxv8b";
const chevronCls = "_61cp2oksr";
const throbberWrapperCls = "_61ts6qhr3";
const throbberCls = "_61t1c1qcrd";
const addToBasketCls = "_61a1ruua1b";

export { addToBasketCls, chevronCls, expandButtonCls, itemContentCls, linkChevron, linkCls, navItemCls, revisionIconWrapper, switchCls, switchTransitionCls, throbberCls, throbberWrapperCls };
import "./nav-item.style.linaria.module.css";
//# sourceMappingURL=nav-item.style.js.map
